import { Component, Input, Output,EventEmitter } from '@angular/core';
 

@Component({
  selector: 'app-demo-popup',
  standalone: true,
  imports: [],
  templateUrl: './demo-popup.component.html',
  styleUrl: './demo-popup.component.scss'
})
export class DemoPopupComponent {
    @Input() demoPopupVisible = false;
    @Output() closeDemoPopupEvent = new EventEmitter<any>();

}
